export default {
  label: {
    button: {
      clearButton: 'Clear all',
    },
  },
};
